import { render, staticRenderFns } from "./ProductButton.vue?vue&type=template&id=081ec09d&scoped=true"
import script from "./ProductButton.vue?vue&type=script&lang=js"
export * from "./ProductButton.vue?vue&type=script&lang=js"
import style0 from "./ProductButton.vue?vue&type=style&index=0&id=081ec09d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081ec09d",
  null
  
)

export default component.exports